import { render, staticRenderFns } from "./static.vue?vue&type=template&id=b7c24f2e&scoped=true"
import script from "./static.vue?vue&type=script&lang=js"
export * from "./static.vue?vue&type=script&lang=js"
import style0 from "./static.vue?vue&type=style&index=0&id=b7c24f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c24f2e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/exam/static.vue
// module id = null
// module chunks = 